import appboy from 'appboy-web-sdk';
import _ from 'lodash';
import Configs from '../constants/configs';

export const initAppboy = (user) => {
	// init appboy with key and user id
	appboy.initialize(Configs.brazeWebKey);

	if (user && user.appboy_user_id) {
		appboy.changeUser(user.appboy_user_id);
	}

	appboy.openSession();
};

export const appyboyUpdateUser = (user) => {
	// Update appboy with user data
	if (user && user.appboy_user_id) {

		initAppboy(user);

		appboy.changeUser(user.appboy_user_id);
		appboy.getUser().setFirstName(user.first_name);
		appboy.getUser().setLastName(user.last_name);

		appboy.getUser().setEmail(user.email || user.unverified_email);

		if (user.birth_date) {
			appboy
				.getUser()
				.setDateOfBirth(
					parseInt(user.birth_date.substring(0, 4), 10),
					parseInt(user.birth_date.substring(5, 7), 10),
					parseInt(user.birth_date.substring(8, 10), 10)
				);
		}

		if (user.gender === 'Male') {
			appboy.getUser().setGender(appboy.ab.User.Genders.MALE, () => {});
		} else if (user.gender === 'Female') {
			appboy.getUser().setGender(appboy.ab.User.Genders.FEMALE, () => {});
		}

		if (user.phone) {
			appboy.getUser().setPhoneNumber(user.phone);
		}
		if (user.postcode) {
			appboy.getUser().setCustomUserAttribute('Postcode', user.postcode);
		}

		appboy
			.getUser()
			.setCustomUserAttribute('IsEmailVerified', user.is_email_verified);
		appboy
			.getUser()
			.setCustomUserAttribute(
				'ProfilePercentage',
				user.profile_percent_complete
			);

		appboy
			.getUser()
			.setCustomUserAttribute(
				'CategoryPreference_EmailNews',
				_.get(user.notifications, 'email.voucher') || false
			);
		appboy
			.getUser()
			.setCustomUserAttribute(
				'CategoryPreference_EmailVouchers',
				_.get(user.notifications, 'email.news') || false
			);
		appboy
			.getUser()
			.setCustomUserAttribute(
				'CategoryPreference_PushVouchers',
				_.get(user.notifications, 'on_screen.voucher') || false
			);
		appboy
			.getUser()
			.setCustomUserAttribute(
				'CategoryPreference_PushNews',
				_.get(user.notifications, 'on_screen.news') || false
			);
		appboy
			.getUser()
			.setCustomUserAttribute('LoyaltyCard', user.loyalty_card_no || false);
	}
};

export const appyboyLoadFeed = (user, containerId) => {
	if (document.getElementById(containerId)) {
		initAppboy(user);
		appboy.display.showFeed(document.getElementById(containerId));
		// appboy.subscribeToFeedUpdates(function(feed) {
		// 	appboy.display.showFeed(document.getElementById(containerId), feed.cards);
		// });
		// appboy.requestFeedRefresh();
	}
};

export const appboyLogCustomEvent = appboy.logCustomEvent;
